module.exports = __webpack_public_path__ + "static/media/smart.0d13fa11.png";